import React from 'react';
import { useAuthorization } from 'framework/authorization';
import { ShowSection } from 'framework/ui/layout';

interface StaffingProjectSectionWrapperProps {
  children: React.ReactNode;
  permissions?: string | string[];
  withMinHeight?: boolean;
  fullHeight?: boolean;
  title?: string | React.ReactElement;
  isVisible?: boolean;
}

const StaffingProjectSectionWrapper = ({
  children,
  permissions,
  withMinHeight = true,
  fullHeight = false,
  title,
  isVisible = true,
}: StaffingProjectSectionWrapperProps) => {
  const { isGranted } = useAuthorization();

  if (!isVisible || (permissions && !isGranted(permissions))) {
    return null;
  }

  return (
    <ShowSection
      title={title}
      sx={(theme: any) => ({
        padding: '22px 20px 20px !important',
        [theme.breakpoints.down('md')]: {
          padding: '18px 16px 18px !important',
        },
        ...(fullHeight && {
          height: 'calc(100% - 20px)',
          display: 'flex',
          flexDirection: 'column',
        }),
        minHeight: withMinHeight ? '200px' : 'unset',
        '.section-details__wrapper': {
          p: '0 !important',
          ...(fullHeight && {
            height: 'calc(100% - 20px)',
            display: 'flex',
            flexDirection: 'column',
          }),
        },
      })}
    >
      {children}
    </ShowSection>
  );
};

export default StaffingProjectSectionWrapper;
